export default __webpack_public_path__ + "static/media/saint-malo2.6cd9767d.jpg";